import {
  Component,
  EventEmitter,
  Output,
  forwardRef,
  OnInit,
  ElementRef,
  Input
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { NgxsOnInit } from '@ngxs/store';
import { AbstractField } from './abstract-field.component';

const customValueProvider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AddressFieldComponent),
  multi: true
};

@Component({
  selector: 'address-field',
  inputs: [...AbstractField.inputs, 'maxLength', 'minLength'],
  outputs: [...AbstractField.outputs, 'onAddressChange'],
  template: `
    <div
      [floatingLabel]="model"
      [focus]="focused"
      [ngClass]="{
        'validation-failed':
          (showValidation || inp.dirty || inp.touched) &&
          required &&
          (!model || model == '' || !inp.valid)
      }"
    >
      <label for="FIELD={{ id }}">{{ label + (required ? '*' : '') }}</label>
      <input
        [autocomplete]="autocomplete"
        [attr.name]="autocomplete"
        id="FIELD-{{ id }}"
        [(ngModel)]="model"
        [placeholder]="label + (required ? ' *' : '')"
        class="form-control"
        (focus)="focused = true"
        (blur)="onBlur($event)"
        (ngModelChange)="onChange($event)"
        [disabled]="disabled"
        [required]="required"
        #inp="ngModel"
        (onAddressChange)="onAddressChange.emit($event)"
        ngx-google-places-autocomplete
        type="text"
        [attr.maxLength]="maxLength ? maxLength : null"
        [attr.minLength]="minLength ? minLength : null"
      />
    </div>
  `,
  providers: [customValueProvider]
})
export class AddressFieldComponent extends AbstractField {
  maxLength = 0;
  minLength = 0;
  onAddressChange = new EventEmitter<Address>();
  constructor() {
    super();
  }
}
